import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["player", "container"]

  open(event) {
    event.preventDefault()

    this.playerTarget.classList.remove("hidden")
    this.playerTarget.classList.add("flex")
    document.body.classList.add("modal-shown")

    if (!this.hasContainerTarget) return

    const embed = event.currentTarget.getAttribute("data-video-embed-data")
    this.containerTarget.innerHTML = embed

    const iframes = this.containerTarget.querySelectorAll('[data-oembed-type="video"] iframe')
    const iframe = Array.from(iframes).find((el) => el.offsetParent !== null)
    if (iframe) {
      const video = iframe.getAttribute("src")
      iframe.setAttribute("src", `${video}&autoplay=1&rel=0`)
    }
  }

  close() {
    if (this.hasContainerTarget) this.containerTarget.innerHTML = ""

    this.playerTarget.classList.remove("flex")
    this.playerTarget.classList.add("hidden")
    document.body.classList.remove("modal-shown")
  }

  escClose(event) {
    if (event.key === "Escape") this.close()
  }
}
